"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CollapsibleContainerHeader = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _coreIcon = _interopRequireDefault(require("@vfuk/core-icon"));

var Styled = _interopRequireWildcard(require("./styles/CollapsibleContainerHeader.style"));

var _CollapsibleContainerContext = require("../../contexts/CollapsibleContainerContext");

var _CollapsibleContainer = _interopRequireDefault(require("../../themes/CollapsibleContainer.theme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var CollapsibleContainerHeader = /*#__PURE__*/function (_PureComponent) {
  _inherits(CollapsibleContainerHeader, _PureComponent);

  var _super = _createSuper(CollapsibleContainerHeader);

  function CollapsibleContainerHeader() {
    var _this;

    _classCallCheck(this, CollapsibleContainerHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    return _this;
  }

  _createClass(CollapsibleContainerHeader, [{
    key: "render",
    value: function render() {
      var appearance = (0, _CollapsibleContainer["default"])(this.props.theme).appearance[this.context.appearance];
      return /*#__PURE__*/_react["default"].createElement(Styled.CollapsibleContainerHeader, {
        onInteraction: this.context.toggle,
        appearance: this.context.appearance,
        isInverse: this.context.isInverse,
        size: this.props.size,
        width: this.context.width
      }, /*#__PURE__*/_react["default"].createElement(Styled.Children, null, this.props.children), /*#__PURE__*/_react["default"].createElement(Styled.IconContainer, {
        isActive: this.context.isActive
      }, /*#__PURE__*/_react["default"].createElement(_coreIcon["default"], {
        appearance: this.context.isInverse ? appearance.inverse.iconAppearance : appearance.iconAppearance,
        inverse: this.context.isInverse ? appearance.inverse.inverseIcon : appearance.inverseIcon,
        name: "chevron-down",
        size: 3
      })));
    }
  }]);

  return CollapsibleContainerHeader;
}(_react.PureComponent);

exports.CollapsibleContainerHeader = CollapsibleContainerHeader;
CollapsibleContainerHeader.defaultProps = {
  size: 2
};
CollapsibleContainerHeader.contextType = _CollapsibleContainerContext.CollapsibleContainerContext;
CollapsibleContainerHeader.displayName = "CollapsibleContainerHeader";

var _default = (0, _styledComponents.withTheme)(CollapsibleContainerHeader);

exports["default"] = _default;
//# sourceMappingURL=CollapsibleContainerHeader.js.map